// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMemo } from 'react';
import { useParties } from '../../../../contexts/PartiesContext';
import useClientOnboarderService from '../onboarding/useClientOnboarderService';
import useComplianceService from '../onboarding/useComplianceService';
import useRegistrarService from '../onboarding/useRegistrarService';

export type DenyListViewMode = 'registrar' | 'compliance' | 'clientOnboarder';

export const useDenyListRole = () => {
  const registrarService = useRegistrarService();
  const complianceService = useComplianceService();
  const clientOnboarderService = useClientOnboarderService();
  const { party } = useParties();

  const isCompliance = complianceService.data?.payload.compliance === party;

  const mode = useMemo<DenyListViewMode | null>(() => {
    if (registrarService.data) return 'registrar';
    if (isCompliance) return 'compliance';
    if (clientOnboarderService.data) return 'clientOnboarder';
    return null;
  }, [registrarService.data, isCompliance, clientOnboarderService.data]);

  return {
    isLoading:
      registrarService.isLoading || complianceService.isLoading || clientOnboarderService.isLoading,
    mode,
  };
};

export default useDenyListRole;
